module.exports = __webpack_public_path__ + "img/terlibat_dilingkungan.0d9578f6.png";